import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { getData } from '../../Helpers/requests';

import { useNavigate } from 'react-router-dom';

import { FormCategory } from '../shared/FormElements';

import { CustomerConstants, getCabinetType } from '../../Helpers/requests';

import { GetAuth } from '../../Auth/AuthProvider';

import DatePicker from '../CommonComponents/DatePicker_v2';
// import { optionsList } from '../../Helpers/helpers';

// import { Debounced } from 'react-debounce-input';

// import { matchSorter } from 'match-sorter';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import {
  Input,
  Button,
  Card,
  Grid,
  Box,
  Stack,
  FormControl,
  Typography,
  TextField,
  Alert,
  Snackbar,
} from '@mui/material';

export default function SerialEditInfoCard({
  closeModel,
  modalData,
  modalMode,
}) {
  const [open, setOpen] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const [selectedCabinetType, setSelectedCabinetType] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedInstaller, setSelectedInstaller] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  const [region, setRegion] = useState(modalData.store_region_guid);
  const [storeCategory, setStoreCategory] = useState(
    modalData.store_category_guid
  );

  // const [cabinetType, setCabinetType] = useState(modalData.cabinet_type_id);

  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [cabinetTypeList, setCabinetTypeList] = useState([]); //Constant - Regions List
  const [customerData, setCustomerData] = useState([]); //Constant - Regions List
  const [usersData, setUsersData] = useState([]); //Constant - User List
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = React.useState(1);

  const [specialname] = useState('%');
  const [specialRegion] = useState(modalData.store_region_guid);
  const [specialCategory] = useState(modalData.store_category_guid);

  const [serialNumber, setSerialNumber] = useState(modalData.serial_number);

  const [storeName, setStoreName] = useState(modalData.store_id);

  const [installDate, setInstallDate] = useState(
    modalData.install_date.slice(0, 10)
  );
  const [waranteeData, setWarranteeData] = useState(modalData.warranty_period);
  // const [installer, setInstaller] = useState(modalData.installer_id);

  const editId = modalData.id;

  //Regions & Category Handlers

  const findGuid = (guid, objectSet) => {
    let found = null;
    for (let i = 0; i < objectSet.length; i++) {
      if (objectSet[i].id === guid) {
        found = objectSet[i];
        break;
      }
    }
    return found;
  };

  useEffect(() => {
    GetData(setStoreCategory, setRegion);
  }, []);

  useEffect(() => {
    let CabinetObj = findGuid(modalData.cabinet_type_id, cabinetTypeList);
    setSelectedCabinetType(CabinetObj);
  }, [cabinetTypeList]);

  useEffect(() => {
    let RegionObj = findGuid(modalData.store_region_guid, region);
    setSelectedRegion(RegionObj);
  }, [region]);

  useEffect(() => {
    let CategoryObj = findGuid(modalData.store_category_guid, storeCategory);
    setSelectedCategory(CategoryObj);
  }, [storeCategory]);

  useEffect(() => {
    let CustomerObj = findGuid(modalData.store_id, customerData);
    setSelectedStore(CustomerObj);
  }, [customerData]);

  useEffect(() => {
    let InstallerObj = findGuid(modalData.installer_id, usersData);
    setSelectedInstaller(InstallerObj);
  }, [usersData]);

  let GetData = (setCategories, setRegions) => {
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');

    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    const request = new Request(`${APIROOT}/api/constants/customer`, {
      method: 'POST',
      headers: headers,
    });
    fetch(request)
      .then((data) => {
        if (data.status === 200) {
          return data.text();
        } else {
          throw new Error(`Invalid Response`);
        }
      })
      .then((data) => {
        var parsed = JSON.parse(data);

        // console.log(parsed);
        if (parsed.success === true) {
          setCategories(parsed.data.value.categories);
          setRegions(parsed.data.value.regions);
        } else {
          console.log(`Error: ${parsed.message}`);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    getCabinetType({
      resource: `/api/warranties`,
      setCabinetTypesFunc: setCabinetTypeList,
      logout,
    });
  }, [logout]);

  //get customer constants
  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: () => {},
      setLoadingFunc: false,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  // const serialId = modalData.id;

  const handleAutoComplete = (event, newValue) => {
    setInstallDate(newValue.slice(0, 10));
  };

  const handleChange = (event) => {
    let checkEvent = event.target.id;

    switch (checkEvent) {
      case 'serialNumberInput':
        setSerialNumber(event.target.value);

        break;

      case 'date':
        setInstallDate(event.target.value.slice(0, 10));
        break;

      case 'warrantee':
        setWarranteeData(event.target.value);
        break;

      default:
      // console.log(
      //   `%cevent Value: ${JSON.stringify(event.target)} NOT SET`,
      //   'color: red;  font-size: 1.5em'
      // );
    }
  };

  // == REGIONS & CATEGORIES HANDLERS == //

  const filterMethod = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
  });

  const filterCabinetOptions = filterMethod;
  const filterRegionsOptions = filterMethod;
  const filterCategoriesOptions = filterMethod;
  const filterStoreOptions = filterMethod;
  const filterInstallerOptions = filterMethod;

  const setCabinet = (event, newValue) => {
    setSelectedCabinetType(newValue);
  };

  const setInstallerInfo = (event, newValue) => {
    // console.log(
    //   `%cevent Value: ${JSON.stringify(newValue)} `,
    //   'color: red;  font-size: 1.5em'
    // );
    setSelectedInstaller(newValue);
  };

  const setStore = (event, newValue) => {
    setSelectedStore(newValue);
  };

  const getNewCustomerfromRegion = async (event, newValue) => {
    let regionValue;
    try {
      setSelectedRegion(newValue);
      regionValue = await newValue.id;
    } catch {
      // console.log('no value');
      regionValue = null;
    }

    if (regionValue && selectedCategory) {
      return getCustomerbyID(regionValue, selectedCategory.id, '%').then(
        (data) => {
          setCustomerData(data.data.value);
          if (data.data.value[0]) {
            setStoreName(data.data.value[0].id);
          } else {
            setStoreName('');
          }
        }
      );
    } else {
      setCustomerData([]);
    }
  };

  const getNewCustomerFromCategory = async (event, newValue) => {
    let categoryValue;
    try {
      setSelectedCategory(newValue);
      categoryValue = await newValue.id;
    } catch {
      // console.log('no value');
      categoryValue = null;
    }

    if (categoryValue && selectedRegion) {
      return getCustomerbyID(selectedRegion.id, categoryValue, '%').then(
        (data) => {
          setCustomerData(data.data.value);
          if (data.data.value[0]) {
            setStoreName(data.data.value[0].id);
          } else {
            setStoreName('');
          }
        }
      );
    } else {
      setCustomerData([]);
    }
  };

  async function getCustomerbyID(searchRegion, searchCategory, searchName) {
    let JWT = localStorage.getItem('JWT_Key');
    let headers = {
      'content-type': 'application/JSON',
    };

    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'special_region',
              search: searchRegion,
              strict: true,
            },
            {
              field: 'special_category',
              search: searchCategory,
              // search: 'FEF791FC-1986-4ACB-B013-781551FC4550',
              strict: true,
            },
            {
              field: 'name',
              search: searchName,
              strict: false,
            },
          ],
        },
      },
    };

    const request = new Request(`${APIROOT}/api/customers`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });

    const response = await fetch(request);

    const data = response.json();
    return data;
  }

  useEffect(() => {
    getData(`users`, {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'name',
              search: '',
              strict: false,
            },
          ],
        },
      },
    }).then((data) => {
      setUsersData(data.data.value);
    });
  }, [forceUpdate]);

  useEffect(() => {
    getCustomerbyID(specialRegion, specialCategory, specialname).then(
      (data) => {
        setCustomerData(data.data.value);
      }
    );
  }, [specialRegion, specialCategory, forceUpdate]);

  const serialEndPoint = (uri) => {
    if (
      serialNumber === '' ||
      serialNumber === undefined ||
      serialNumber === null
    ) {
      setOpen(true);
    } else if (
      selectedCabinetType === '' ||
      selectedCabinetType === undefined ||
      selectedCabinetType === null
    ) {
      setOpen(true);
    } else if (
      selectedCategory === '' ||
      selectedCategory === undefined ||
      selectedCategory === null
    ) {
      setOpen(true);
    } else if (
      selectedInstaller === '' ||
      selectedInstaller === undefined ||
      selectedInstaller === null
    ) {
      setOpen(true);
    } else if (
      selectedRegion === '' ||
      selectedRegion === undefined ||
      selectedRegion === null
    ) {
      setOpen(true);
    } else if (
      selectedStore === '' ||
      selectedStore === undefined ||
      selectedStore === null
    ) {
      setOpen(true);
    } else if (
      installDate === '' ||
      installDate === undefined ||
      installDate === null
    ) {
      setOpen(true);
    } else {
      const DataBlob = {
        serial: {
          serial_number: serialNumber,
          cabinet_type_id: selectedCabinetType.id,
          store_id: selectedStore.id,
          installer_id: selectedInstaller.id,
          install_date: installDate.slice(0, 10),
          warranty_period: waranteeData,
        },
      };

      //Get JWT from storage
      let JWT = localStorage.getItem('JWT_Key');
      //Set default Headers
      let headers = {
        'content-type': 'application/JSON',
      };
      //Set JWT in header if available
      if (JWT) {
        headers['x-api-key'] = JWT;
      }
      let body = {};

      body = DataBlob;
      const request = new Request(`${APIROOT}/api${uri}`, {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      });

      fetch(request)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error(`Failed to save serial`);
          }
        })
        .then((data) => {
          let parsed = JSON.parse(data);
          if (parsed.success === true) {
            setForceUpdate((val) => val + 1);
            //Update JWT if required
            if (parsed.JWT) {
              localStorage.setItem('JWT_Key', parsed.JWT);
            }
            closeModel();
            navigateBack(`/Serial`, { replace: true });
          } else {
            //Force logout
            if (parsed.message === 'Please login') {
              logout(() => {
                enqNotification('Session Expired', 'warning');
              });
            } else {
              enqNotification(parsed.message, 'error');
            }
          }
        })
        .catch((error) => {
          enqNotification(
            typeof error == 'string' ? error : 'Connection Error',
            'error'
          );
        });
    }
  };

  const navigateBack = useNavigate();

  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          // borderRadius: 15,
          padding: '5px 10px 5px 5px',
          height: '80vh',
          display: 'block',
          overflow: 'scroll',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5' sx={{ height: 40 }}>
            Cabinet Detail
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Card sx={{ boxShadow: 'none', border: 'none', background: 'none' }}>
            <Box sx={{ width: '100%' }}>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={0.5}
              >
                <Grid item xs={12} md={2}>
                  <FormCategory title='Serial Number:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      height: '40px',
                      borderRadius: 0.5,
                      padding: '10px',
                      border: 'none',
                    }}
                    label={serialNumber === null ? 'required' : ''}
                    InputLabelProps={{
                      style: {
                        color: serialNumber === null ? '#ff0000' : '#000000',
                      },
                    }}
                    variant='standard'
                    // size='small'
                    name='serialNumberInput'
                    key='serialNumberInput'
                    id='serialNumberInput'
                    onChange={handleChange}
                    value={serialNumber}
                    defaultValue={serialNumber}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Cabinet Type:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      padding: 0,
                    }}
                    name='cabinetType'
                    key='cabinetType'
                    id='cabinetType'
                    variant='standard'
                    size='small'
                    value={selectedCabinetType}
                    onChange={setCabinet}
                    disablePortal
                    options={cabinetTypeList}
                    filterOptions={filterCabinetOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Store Category:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#cccccc',
                      padding: 0,
                    }}
                    name='category'
                    key='category'
                    id='category'
                    variant='standard'
                    size='small'
                    value={selectedCategory}
                    onChange={getNewCustomerFromCategory}
                    disablePortal
                    options={categoriesData}
                    filterOptions={filterCategoriesOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <FormCategory title='Region:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#cccccc',
                      padding: 0,
                    }}
                    name='region'
                    key='region'
                    id='region'
                    variant='standard'
                    size='small'
                    value={selectedRegion}
                    onChange={getNewCustomerfromRegion}
                    disablePortal
                    options={regionsData}
                    filterOptions={filterRegionsOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Customer Name:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      padding: 0,
                    }}
                    error={selectedStore === null ? true : false}
                    name='store'
                    key='store'
                    id='store'
                    variant='standard'
                    size='small'
                    value={selectedStore}
                    onChange={setStore}
                    disablePortal
                    options={customerData}
                    filterOptions={filterStoreOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={selectedStore === null ? 'required' : ''}
                        InputLabelProps={{
                          style: {
                            color:
                              selectedStore === null ? '#ff0000' : '#000000',
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Install Date:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DatePicker
                    // dateLabel='End Date'
                    getDate={(data) => handleAutoComplete('rangeStart', data)}
                    // value={filterModalEventFields.startDate}
                    // value={dayjs(filterModalEventFields.startDate)}
                    defaultDate={installDate}
                  />
                  {/* <TextField
                    id='date'
                    key='date'
                    name='date'
                    type='date'
                    onChange={handleChange}
                    value={installDate}
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      height: '40px',

                      padding: '5px 10px',
                    }}
                    variant='standard'
                    InputLabelProps={{
                      shrink: true,
                    }}
                  /> */}
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Warrantee Period (Years):' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      height: '40px',
                      padding: '10px',
                    }}
                    name='warrantee'
                    key='warrantee'
                    id='warrantee'
                    onChange={handleChange}
                    value={waranteeData}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Installer:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  {/* <FormControl
                    variant='standard'
                    sx={{
                      m: 0,
                      width: '100%',
                      minWidth: 120,
                      background: '#fff',
                    }}
                  > */}
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      padding: 0,
                    }}
                    name='installer'
                    key='installer'
                    id='installer'
                    variant='standard'
                    size='small'
                    value={selectedInstaller}
                    onChange={setInstallerInfo}
                    disablePortal
                    options={usersData}
                    filterOptions={filterInstallerOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                  {/* </FormControl> */}
                </Grid>
                <Grid item xs={12} md={12}>
                  <Stack
                    spacing={2}
                    direction='row'
                    sx={{ float: 'right', margin: '15px' }}
                  >
                    <Button
                      variant='contained'
                      onClick={() => {
                        serialEndPoint(
                          modalMode === 'editMode'
                            ? `/serialnumbers/${editId}`
                            : `/serialnumbers`
                        );
                      }}
                    >
                      Save
                    </Button>

                    <Button
                      variant='outlined'
                      onClick={() => {
                        closeModel();
                        navigateBack(`/Serial`, { replace: true });
                      }}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error' sx={{ width: '100%' }}>
          Complete all empty fields before saving!
        </Alert>
      </Snackbar>
    </Box>
  );
}
